import script from "./XintuTalent.vue?vue&type=script&setup=true&lang=js"
export * from "./XintuTalent.vue?vue&type=script&setup=true&lang=js"

import "./XintuTalent.vue?vue&type=style&index=0&id=34cfdad4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34cfdad4"]])

export default __exports__